var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    { staticClass: "emd-menu menu" },
    [
      _c(
        "div",
        { staticClass: "overflow-auto px-2" },
        [
          _vm._l(_vm.menu, function (item) {
            return [
              item.showSection
                ? _c(
                    "app-menu-item",
                    {
                      key: item.key,
                      attrs: { item: item, routeName: _vm.routeName },
                    },
                    [
                      item.items
                        ? _c("app-menu-subitems", {
                            attrs: { subitems: item.items },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
      _c("app-menu-footer", {
        attrs: { accountId: _vm.accountId, merchantId: _vm.merchantId },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }